// extracted by mini-css-extract-plugin
export default {"body":"style_body__Ecygt","fadeIn":"style_fadeIn__dPT4p"};